import React, { memo } from 'react';
import classNames from 'classnames';

import './Tabs.scss';

interface TabsProps {
  children: React.ReactNode;
  /** Splits the container's full width evenly between the tabs, from tablet up. */
  fullWidth?: boolean;
  onChange(tabId: string): void;
}

const Tabs = ({ children, fullWidth = false, onChange }: TabsProps) => {
  return <nav styleName={classNames('tabs', { 'tabs--full-width': fullWidth })}>
    {React.Children.map(children, child => {
      return React.cloneElement(child, { onChange });
    })}
  </nav>;
};

export default memo(Tabs);
